export const AIRSalesDemoTrackingIds = {
  salesDemoHeaderButton: 'air-sales-demo-header-button',
  salesDemoPanelCloseButton: 'air-sales-demo-panel-close-button',
  salesDemoStartDemoButton: 'air-sales-demo-start-demo-button',
};
